// ABOUTME: Square, contained image of a catalog card, with the camera placeholder when there is none.
// ABOUTME: Shared by the treeview family cards, product rows and favorites, sized by the caller.

import { CameraAltOutlinedIcon, Img, Stack } from '@ds/coolshop';
import { useState } from 'react';

interface CatalogThumbnailProps {
    url: string | undefined;
    alt: string;
    /** A CSS length; unset, the thumbnail fills its container's width. */
    size?: string;
}

/**
 * The image keeps its square box when it is missing or fails to load, so cards of a row stay
 * aligned whatever their images.
 */
export function CatalogThumbnail({ url, alt, size }: CatalogThumbnailProps) {
    const [failed, setFailed] = useState(false);
    const width = size ?? '100%';
    if (url && !failed) {
        return (
            <Img
                src={url}
                alt={alt}
                objectFit="contain"
                aspectRatio={1}
                width={width}
                flexShrink={0}
                borderRadius={1}
                onError={() => setFailed(true)}
            />
        );
    }
    return (
        <Stack
            alignItems="center"
            justifyContent="center"
            aspectRatio={1}
            width={width}
            flexShrink={0}
            color="text.disabled"
        >
            <CameraAltOutlinedIcon />
        </Stack>
    );
}
